module.exports = __webpack_public_path__ + "static/media/img5.0dbfc1a6.png";